module.exports = __webpack_public_path__ + "static/media/CorrugatedImg3.266b0c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorrugatedImg3.jpg
// module id = 1161
// module chunks = 0